var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8833 2.99189L17.0083 4.11689C17.6667 4.76689 17.6667 5.82523 17.0083 6.47523L5.98333 17.5002H2.5V14.0169L11.1667 5.34189L13.525 2.99189C14.175 2.34189 15.2333 2.34189 15.8833 2.99189ZM4.16667 15.8336L5.34167 15.8836L13.525 7.69189L12.35 6.51689L4.16667 14.7002V15.8336Z",
    fill: "#6D6E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.859d9050ee73d3820531816173aba41d.svg";
export { ForwardRef as ReactComponent };